import styled from "styled-components"

export const ViewOrdersButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 1rem;
  border: 0.1rem solid ${(p) => p.theme.colors.greyDark};
  border-radius: 0.4rem;
  background: ${(p) => p.theme.colors.white};
  color: ${(p) => p.theme.colors.black};
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  svg {
    height: 1.2rem;
    fill: ${(p) => p.theme.colors.black};
    transition: all 0.2s;
  }

  &:hover {
    background: ${(p) => p.theme.colors.turquoiseDark};
    border-color: ${(p) => p.theme.colors.turquoiseDark};
    color: ${(p) => p.theme.colors.white};

    svg {
      fill: ${(p) => p.theme.colors.white};
    }
  }
`
